var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCamera128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2252_9238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1529 18.5247H72.8474C76.4479 18.5247 79.6418 20.8353 80.7683 24.255L83.4593 32.424H44.541L47.232 24.255C48.3585 20.8353 51.5524 18.5247 55.1529 18.5247Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.692 24.0844H29.2517C30.787 24.0844 32.0316 25.329 32.0316 26.8643V32.424H20.9121V26.8643C20.9121 25.329 22.1567 24.0844 23.692 24.0844Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.868 32.4241H18.1321C13.5263 32.4241 9.79248 36.1579 9.79248 40.7637V99.1411C9.79248 103.747 13.5263 107.481 18.1321 107.481H109.868C114.474 107.481 118.208 103.747 118.208 99.1411V40.7637C118.208 36.1579 114.474 32.4241 109.868 32.4241Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 97.7512C79.3528 97.7512 91.7987 85.3052 91.7987 69.9524C91.7987 54.5996 79.3528 42.1536 63.9999 42.1536C48.6471 42.1536 36.2012 54.5996 36.2012 69.9524C36.2012 85.3052 48.6471 97.7512 63.9999 97.7512Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.308 51.8832C106.611 51.8832 108.478 50.0163 108.478 47.7134C108.478 45.4105 106.611 43.5436 104.308 43.5436C102.006 43.5436 100.139 45.4105 100.139 47.7134C100.139 50.0163 102.006 51.8832 104.308 51.8832Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2252_9238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCamera128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCamera128.959b5cfe9b8447f648ba7959b1866f3b.svg";
export { ForwardRef as ReactComponent };